const MINIMUM_CHARACTERS = {
  regex: /^.{8,}$/,
  formatError: 'password_requires_minimum_of_characters',
}
const CONTAINS_UPPERCASE = {
  regex: /[A-Z]/,
  formatError: 'password_requires_upper_case',
}
const CONTAINS_LOWERCASE = {
  regex: /[a-z]/,
  formatError: 'password_requires_lower_case',
}
const CONTAINS_DIGIT = { regex: /\d/, formatError: 'password_requires_digit' }
const CONTAINS_SPECIAL_CHARACTER = {
  regex: /[!"#$%&'()*+,./:;<=>?@[\\\]^_{|}-]/g,
  formatError: 'password_requires_special_character',
}
const DEFAULT_6CHARACTERS = /^.{6,}$/
const passwordValidations = [
  MINIMUM_CHARACTERS,
  CONTAINS_UPPERCASE,
  CONTAINS_LOWERCASE,
  CONTAINS_DIGIT,
  CONTAINS_SPECIAL_CHARACTER,
]

export const checkPasswordRequirements = ({
  value,
  showPasswordRequirements,
}: {
  value: string
  showPasswordRequirements: boolean
}) => {
  if (showPasswordRequirements) {
    return passwordValidations.every(
      (validations) => !new RegExp(validations.regex).test(value) === false,
    )
  }
  return new RegExp(DEFAULT_6CHARACTERS).test(value)
}

export const getAllPasswordRequirements = ({ value }: { value: string }) =>
  passwordValidations.map((validation) => {
    const validated = new RegExp(validation.regex).test(value)
    const requirement = { validated, error: validation.formatError }

    return requirement
  })
